const getTicketData = () => {
    return window.localStorage.getItem('ticketInfo') ? JSON.parse(window.localStorage.getItem('ticketInfo')) : {} ;
};

const isTicketClaimed = (ticketData) => {
    return ticketData && ticketData.ticketStatus === 'Claimed';
};

const setTicketData = (obj) => {
    window.localStorage.setItem('ticketInfo', JSON.stringify(obj) );
};

export { getTicketData, isTicketClaimed, setTicketData };